"use client";

import React from "react";
import { Activity, Compass } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function EnergyOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.15
  });
  return <section id="energyrequirementsoverview" data-nav="light" ref={ref} className="bg-background text-foreground py-16 md:py-24 transition-opacity duration-700 ease-out" style={{
    opacity: isVisible ? 1 : 0
  }}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground">
            A better starting point for understanding energy requirements
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          <Card className="border border-border/70 shadow-xs bg-card/60 backdrop-blur-xs flex flex-col justify-between">
            <CardContent className="p-6 sm:p-8 space-y-4">
              <div className="size-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                <Activity className="size-5" aria-hidden="true" />
              </div>
              <p className="text-base sm:text-lg leading-relaxed text-card-foreground">
                Generic calorie equations estimate metabolism from population averages. An RMR assessment measures your individual resting energy expenditure.
              </p>
            </CardContent>
          </Card>

          <Card className="border border-border/70 shadow-xs bg-card/60 backdrop-blur-xs flex flex-col justify-between">
            <CardContent className="p-6 sm:p-8 space-y-4">
              <div className="size-10 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                <Compass className="size-5" aria-hidden="true" />
              </div>
              <p className="text-base sm:text-lg leading-relaxed text-muted-foreground">
                That measurement can form one part of wider nutrition or body-composition planning alongside activity level, goals, dietary intake and professional nutritional advice where required.
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}